<template>
    <div>
        <div class="d-flex align-center border-sm rounded pa-2 global-card-background">
            <v-btn density="compact" size="small" elevation="0" variant="text" icon="mdi-delete" color="primary" v-if="item.total == 1" @click="remove()"/>
            <v-btn density="compact" size="small" elevation="0" variant="text" icon="mdi-minus" color="primary" v-else @click="decrease()"/>
            <strong class="mx-2">{{ item.total }}</strong>
            <v-btn density="compact" size="small" elevation="0" variant="text" icon="mdi-plus" color="primary"  @click="increase()"/>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        item: {
            type: Object,
            required: true,
            default: () => ({ total: 0 })
        }
    },
    methods:{
        decrease(){
            this.$emit("decrease")
        },
        increase(){
            this.$emit("increase")
        },
        remove(){
            this.$emit("remove")
        },
    }
}
</script>